import React from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { chunk } from 'utils/arrays';
import { ensureKeyed } from 'utils';
import Select from 'react-select';

const renderFilter = ({filterType = '', options, solrPrompt}) => {
  if (filterType === 'TextFilter') {
    return <Field name={solrPrompt} className={'form-control form-control-sm'} />;
  }

  if (filterType === 'NumberFilter') {
    return <Field name={solrPrompt} className={'form-control form-control-sm'} type={'number'} step={'.01'} />;
  }

  const { values, setFieldValue } = useFormikContext();

  if (filterType === 'ManyOptionsFilter') {
    return (
      <Field
        name={solrPrompt}
      >
        {() => (
          <Select
            className='many-options-filter-select'
            clearable
            multi
            value={values[solrPrompt]}
            options={options.map(s => ({ value: s[1], label: s[0] }))}
            onChange={(selected) => setFieldValue(solrPrompt, selected.map(({ value }) => (value)))}
          />
        )}
      </Field>
    );
  }

  return chunk(options, 6).map(row => (
    <div className={'row'}>
      {
        row.map(option => {
          let name;
          let value;

          if (typeof option === 'string') {
            name = option;
            value = option;
          } else {
            [name, value] = option;
          }

          return (
            <div className={'col-4'}>
              <div className="form-check">
                <label>
                  {typeof value === 'boolean' ? (
                    <Field
                      name={solrPrompt}
                      type={'checkbox'}
                      value={value}
                      className={'form-check-input'}
                      onChange={() => {
                        if (values[solrPrompt].includes(value)) {
                          setFieldValue(solrPrompt, []);
                        } else {
                          setFieldValue(solrPrompt, [value]);
                        }
                      }}
                    />
                  ) : (
                    <Field
                      name={solrPrompt}
                      type={'checkbox'}
                      value={value}
                      className={'form-check-input'}
                    />
                  )}
                  {name}
                </label>

              </div>
            </div>
          );
        }).map(ensureKeyed())
      }
    </div>
  )).map(ensureKeyed(solrPrompt));
};

const FilterSet = ({ displayName, tooltip, ...params }) => (
  <div className='contact-filter-react-checkboxes'>
    <div className='contact-filter-react-header'>
      {displayName}
      {tooltip}
    </div>

    {renderFilter(params)}
  </div>
);

FilterSet.propTypes = {
  displayName: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.array)
  ]),
  solrPrompt: PropTypes.string,
  tooltip: PropTypes.node,
};

FilterSet.defaultProps = {
  displayName: '',
  options: [],
  solrPrompt: '',
  tooltip: null,
};

export default FilterSet;
